export const ROLES_DASHBOARD_CAMBIO = ['admin', 'colaborador_satya', 'report_access_all']

export const ROLES_DASHBOARD_INVOICE = [
  'admin',
  'colaborador_satya',
  'financeiro',
  'cliente',
  'report_access_all',
  'colaborador_prana'
]

export const ROLES_DASHBOARD_SATYA = [...new Set([...ROLES_DASHBOARD_CAMBIO, ...ROLES_DASHBOARD_INVOICE])]
